import type { RootState } from 'models';

export const selectOpeningInfo = ({ openingHours }: RootState) => openingHours;
export const selectOpeningHours = ({ openingHours }: RootState) => openingHours.data;
export const selectOpeningHoursLoading = ({ openingHours }: RootState) => openingHours.loading;
